/**
 * Copyright (c) 2025 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React, { useState, useEffect } from 'react';

import { MoneyInput } from '@blend/consumer-components';
import { inputFormatters } from '@blend/shared-react';

export const MoneyInputWrapper = (props?: {
  htmlProps?: React.HTMLAttributes<HTMLInputElement>;
  defaultValue?: number | string | boolean;
  onChange?: (value: number) => void;
}) => {
  const defaultMoney = +(props?.defaultValue ?? 0);
  const [moneyCents, setMoneyCents] = useState<number>(defaultMoney);

  useEffect(() => {
    const newValue = +(props?.defaultValue ?? 0);

    if (newValue !== moneyCents) {
      setMoneyCents(newValue);
    }
  }, [props?.defaultValue]);

  return (
    <MoneyInput
      {...props?.htmlProps}
      format={inputFormatters.MONEY.formatRoundedWithDollarSign}
      normalize={normalizeValue}
      value={moneyCents}
      onChange={(e: any) => {
        setMoneyCents(e.target.value);
        if (props?.onChange) {
          props.onChange(e.target.value);
        }
      }}
      style={{
        width: '100%',
        lineHeight: 20,
        height: 50,
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: '#757575',
        borderRadius: 4,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        padding: 14,
        boxShadow: 'inset 0px 0px 1px 1px #FAFAFA, 0px 0px 7px 0px rgba(0, 152, 217, 0)',
      }}
    />
  );
};

const normalizeValue = (value: string | number) => {
  const normalizedValue = inputFormatters.MONEY.normalize(value);
  const numericValue = parseFloat(normalizedValue);

  if (isNaN(numericValue)) {
    return '';
  }
  if (numericValue > 30) {
    return '30.00';
  }
  if (numericValue < 0) {
    return '0.00';
  }

  return normalizedValue;
};
